import { Component, OnInit, Input } from '@angular/core';
import { RemitaService } from '../_services/remita.service';
import { DataService } from '../_services/index';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
@Component({
  selector: 'app-customer-remita',
  templateUrl: './customer-remita.component.html',
  styleUrls: ['./customer-remita.component.css']
})
export class CustomerRemitaComponent implements OnInit {
  section_open = "basicInfo";
  @Input('userId') userId: any;
  @Input('currentUser') currentUser: any;
  loading = false;
  remita_records: any;
  record_found = false;
  sub: any;
  parentRouteId: any;
  constructor(public router: Router, public route: ActivatedRoute, public remitaService: RemitaService, public dataservice: DataService) { }

  ngOnInit() {
    this.initialize();
  }
  initialize(){
    this.loading = true;
    this.remitaService.getRemitaRecords(this.currentUser.token, this.userId)
      .subscribe(data => {
        if (data.status == true) {
          this.remita_records = data.data;
          this.record_found = true;
        } else {
          this.record_found = false;
        }

      });
  }
  toogleView(section) {
    this.section_open = section;
  }
  refreshRemitaRecords(records: any) {
    this.dataservice.refreshRemitaDetails.emit({ remita_records: records });
  }
  getNewRemitaRecords() {
    this.sub = this.route.parent.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.loading = true;
      this.remitaService.getNewRemitaRecords(this.currentUser.token, this.parentRouteId)
        .subscribe(data => {
          this.initialize();
          if (data.status == true) {
            this.remita_records = data.data;
            this.record_found = true;
          } else {
            this.record_found = false;
          }

        });
    });
  }

}
